var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[(_vm.$store.state.tasks.length)?_c('list-tasks'):_c('no-tasks'),(_vm.$store.state.sorting)?_c('button-done-sorting'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }